import { reactive } from 'vue'

const state = reactive({
  historyCards: []
})

export default state
